import { LoadingSkeleton } from '@/components/atoms/LoadingSkeleton';

export const SummaryLoader = () => (
  <div className="space-y-8">
    <div className="rounded-md border-2 border-gray-200/60 bg-white p-4">
      <LoadingSkeleton className="mb-2 h-6 w-24" />
      <LoadingSkeleton className="mb-2 h-4 w-full" />
      <LoadingSkeleton className="mb-2 h-4 w-3/4" />
      <LoadingSkeleton className="h-4 w-1/2" />
    </div>

    <div className="flex w-full justify-between gap-8">
      <div className="w-1/2 rounded-md border-2 border-gray-200/60 bg-white p-4">
        <LoadingSkeleton className="mb-4 h-6 w-32" />
        <LoadingSkeleton className="mb-2 h-4 w-full" />
        <LoadingSkeleton className="mb-2 h-4 w-3/4" />
      </div>
      <div className="w-1/2 rounded-md border-2 border-gray-200/60 bg-white p-4">
        <LoadingSkeleton className="mb-4 h-6 w-32" />
        <LoadingSkeleton className="mb-2 h-4 w-full" />
        <LoadingSkeleton className="mb-2 h-4 w-3/4" />
      </div>
    </div>

    <div className="rounded-md border-2 border-gray-200/60 bg-white p-4">
      <LoadingSkeleton className="mb-4 h-6 w-32" />
      <div className="space-y-2">
        <LoadingSkeleton className="h-12 w-full" />
        <LoadingSkeleton className="h-12 w-full" />
        <LoadingSkeleton className="h-12 w-full" />
      </div>
    </div>
  </div>
);
